/*
 * fn: getBulkExportLink
 *
 * Gets a link for bulk export of a list of cards for the various brands
 *
 */
import { type BrandType } from '@/defs/brand'
import { encodeBytesToBase64 } from '@/utils/commonUtil'

import { getImpactLink } from './getImpactLink'

type Props = {
  brand: BrandType
  decklist: string[]
  medium?: string
  partner?: string
}

const CONFIG: Partial<Record<BrandType, (props: Props) => string>> = {
  archidekt: ({ decklist }: Props) => {
    const params = new URLSearchParams({
      c: decklist.join('\n'),
    })
    return `https://archidekt.com/cardImport?${params.toString()}`
  },
  cardkingdom: ({ decklist, medium = 'decklist', partner = 'edhrec' }: Props) => {
    const params = new URLSearchParams({
      c: decklist.join('\n'),
      partner,
      partner_args: `edhrec,${medium}`,
      utm_campaign: 'edhrec',
      utm_medium: medium,
      utm_source: 'edhrec',
    })
    return `https://www.cardkingdom.com/builder?${params.toString()}`
  },
  manapool: ({ decklist, medium = 'decklist' }: Props) => {
    const params = new URLSearchParams({
      deck: encodeBytesToBase64(decklist.join('\n')).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''),
      ref: 'scm',
      ref_meta: `referrer:edhrec,${medium}`,
    })
    return `https://manapool.com/add-deck?${params.toString()}`
  },
  moxfield: ({ decklist }: Props) => {
    const params = new URLSearchParams({
      c: decklist.join('\n'),
    })
    return `https://www.moxfield.com/import?${params.toString()}`
  },
  tcgplayer: ({ decklist, medium = 'decklist' }: Props) => {
    const params = new URLSearchParams({
      c: decklist.join('||'),
    })
    return getImpactLink({
      brand: 'tcgplayer',
      subId1: `edhrec,${medium}`,
      u: `https://store.tcgplayer.com/massentry?${params.toString()}`,
    })
  },
}

export const getBulkExportLink = (props: Props) => CONFIG[props.brand]?.(props) || ''
